import React, { FC } from 'react';
import styled from 'styled-components/macro';
import { Trans } from '@lingui/macro';

import { Radio, RadioLabel } from 'components/Form/styled';

const Root = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;

    margin: ${({ theme }) => theme.space.xlarge} 0;

    & > .YearlyBlock {
        position: relative;
    }
`;

const Savings = styled.div`
    position: absolute;

    top: -18px;
    left: 24px;

    display: flex;
    align-items: center;
    justify-content: center;

    & > span {
        font-size: 10px;
        line-height: 150%;
        font-weight: 700;
        white-space: nowrap;
        color: ${({ theme }) => theme.colors.darkGrey};
        margin-left: ${({ theme }) => theme.space.tiny};
    }
`;

const Star = () => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="10"
        height="10"
        viewBox="0 0 10 10"
        fill="none"
    >
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M2.07981 9.73544C2.06495 9.72715 2.04895 9.71801 2.03038 9.70886C1.78779 9.58857 1.64407 9.31741 1.64407 8.98253C1.64407 8.9591 1.64607 8.93595 1.6495 8.91281L2.05438 6.45521L0.251401 4.75823C0.0210998 4.53051 -0.0563341 4.21248 0.0413869 3.92046C0.137394 3.64159 0.333693 3.44786 0.610855 3.35757C0.634285 3.35014 3.16017 2.98268 3.16017 2.98268L4.19453 0.800534C4.2031 0.782247 4.21339 0.764531 4.22453 0.747387C4.4054 0.475083 4.68628 0.3125 4.97658 0.3125C5.30175 0.3125 5.50291 0.512514 5.6232 0.632236C5.65492 0.663667 5.68149 0.699955 5.70206 0.739958L6.83128 2.93382L9.24602 3.28785C9.56462 3.30356 9.85406 3.51815 9.95807 3.82074C10.0561 4.11362 9.97922 4.4305 9.75949 4.65166L7.99765 6.39606L8.44825 8.80566C8.45282 8.83166 8.4554 8.85795 8.4554 8.88423C8.4554 9.15111 8.3571 9.40341 8.18538 9.57685C8.16395 9.59914 8.13966 9.61857 8.11366 9.63543C7.94365 9.74544 7.66477 9.85116 7.30189 9.73029C7.2816 9.72401 7.26246 9.71572 7.2436 9.70629L5.0303 8.58793L2.86501 9.75001C2.83444 9.76658 2.80186 9.77915 2.76786 9.78801L2.57099 9.83773C2.5367 9.8463 2.50127 9.85087 2.46584 9.85087C2.28154 9.85087 2.15525 9.77858 2.07981 9.73544Z"
            fill="#F6C863"
        />
    </svg>
);

type PlansToggleProps = {
    filters: {
        [key: string]: string;
    };
    currentFilter: string;
    onFilterChange: (filter: string) => void;
} & React.HTMLAttributes<HTMLDivElement>;

const PlansToggle: FC<PlansToggleProps> = ({
    onFilterChange,
    currentFilter,
    filters,
    ...rest
}) => {
    return (
        <Root {...rest}>
            <div>
                <Radio
                    $color="darkGrey"
                    type="radio"
                    id="monthly_input"
                    name="plan_period_switch"
                    value={filters.monthly}
                    checked={currentFilter === filters.monthly}
                    readOnly
                    onClick={() => onFilterChange(filters.monthly)}
                />
                <RadioLabel htmlFor="monthly_input">
                    <Trans>Monthly</Trans>
                </RadioLabel>
            </div>
            <div className="YearlyBlock">
                <Radio
                    $color="darkGrey"
                    type="radio"
                    id="yearly_input"
                    name="plan_period_switch"
                    value={filters.yearly}
                    checked={currentFilter === filters.yearly}
                    readOnly
                    onClick={() => onFilterChange(filters.yearly)}
                />
                <RadioLabel htmlFor="yearly_input">
                    <Trans>Yearly</Trans>
                </RadioLabel>
                <Savings>
                    <Star />
                    <span>
                        <Trans>Save up to 50%</Trans>
                    </span>
                </Savings>
            </div>
        </Root>
    );
};

export default PlansToggle;
